import * as React from 'react';
import GET_REFUND_REASONS from 'coaching/queries/GetRefundReasons.gql';
import { ApolloError } from 'apollo-client';
import { Query } from 'react-apollo';
import {
  GetRefundReasons,
  GetRefundReasons_coaching_getRefundReasons,
} from 'coaching/queries/__generated__/GetRefundReasons';

export type Props = {
  children: (props: {
    refundReasons: GetRefundReasons_coaching_getRefundReasons[];
    loading: boolean;
    error?: ApolloError;
  }) => React.ReactNode;
};

export default function GetRefundReasonsContainer(props: Props) {
  return (
    <Query<GetRefundReasons> query={GET_REFUND_REASONS}>
      {({ loading, error, data }) => {
        return props.children({
          refundReasons: data?.coaching_getRefundReasons ?? [],
          loading,
          error,
        });
      }}
    </Query>
  );
}
